var _defs, _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgForEngineers = function SvgForEngineers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 400 400"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "for_engineers_svg__a",
    x1: 200,
    y1: 300.39,
    x2: 200,
    y2: 111.78,
    gradientTransform: "translate(0 402) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#ad55fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a5afb"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 101.61,
    y: 101.61,
    width: 196.78,
    height: 196.78,
    rx: 46.23,
    ry: 46.23,
    fill: "url(#for_engineers_svg__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m265.69,180.72v-4.56h-11.24v-9.69c0-11.53-9.38-20.92-20.92-20.92h-9.5v-11.06h-4.56v11.06h-17.18v-11.06h-4.56v11.06h-17.18v-11.06h-4.56v11.06h-9.5c-11.53,0-20.92,9.38-20.92,20.92v9.69h-11.24v4.56h11.24v17.18h-11.24v4.56h11.24v17.18h-11.24v4.56h11.24v9.32c0,11.53,9.38,20.92,20.92,20.92h9.5v11.42h4.56v-11.42h17.18v11.42h4.56v-11.42h17.18v11.42h4.56v-11.42h9.5c11.53,0,20.92-9.38,20.92-20.92v-9.32h11.24v-4.56h-11.24v-17.18h11.24v-4.56h-11.24v-17.18h11.24Zm-15.8,52.81c0,9.02-7.34,16.36-16.36,16.36h-67.05c-9.02,0-16.36-7.34-16.36-16.36v-67.06c0-9.02,7.34-16.36,16.36-16.36h67.05c9.02,0,16.36,7.34,16.36,16.36v67.06Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m229.65,165.11h-59.3c-2.89,0-5.24,2.35-5.24,5.25v59.3c0,2.89,2.35,5.25,5.24,5.25h59.3c2.89,0,5.24-2.35,5.24-5.25v-59.3c0-2.89-2.35-5.25-5.24-5.25Zm.68,64.54c0,.38-.31.68-.68.68h-59.3c-.38,0-.68-.31-.68-.68v-59.3c0-.38.31-.68.68-.68h59.3c.38,0,.68.31.68.68v59.3Z",
    fill: "#fff"
  })));
};
export default SvgForEngineers;